import { Inline, Stack, Text } from '@lightspeed/design-system-react'
import { T, useT } from '@transifex/react'
import React from 'react'
import { NOTE_MAX_CHAR } from '../../../../../models/fulfilment'
import { NoteError, NoteInput } from '../../../../shared/NoteInput'

export const TContext = 'Line item fulfilment tab'

type LineItemFulfilmentNoteProps = {
  note: string
  isDisabled?: boolean
  onChange: (note: string) => void
  onErrorsChange?: (errors: NoteError[]) => void
}

export const LineItemFulfilmentNoteLegacy: React.FC<LineItemFulfilmentNoteProps> = ({
  note,
  isDisabled,
  onChange,
  onErrorsChange,
}) => {
  const t = useT()

  return (
    <Stack space={2}>
      <Inline space={1} className="vd-flex--align-center">
        <Text type="label">
          <T _str="Fulfillment Note" _context={TContext} />
        </Text>
        <Text type="supplementary">
          <T
            _str="Items that require fulfillment share this note"
            _context={TContext}
          />
        </Text>
      </Inline>

      <NoteInput
        dataTestId="fulfilment-note"
        disabled={!!isDisabled}
        note={note}
        onChange={event => onChange(event.target.value)}
        rows={1}
        charLimit={NOTE_MAX_CHAR}
        placeholder={t('Enter a fulfillment note', { _context: TContext })}
        onErrorsChange={onErrorsChange}
      />
    </Stack>
  )
}
